import { PARK } from '../../design/tokens';

/** Sage til "familie"-delen af split-bars (Forrest = hovedmedlem). */
export const ACCENT_SOFT = PARK.sage;

const MONTHS = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

/** "jun 26" (withYear) eller "jun". */
export function statMonthLabel(p: { year: number; month: number }, withYear = false): string {
  const l = MONTHS[p.month - 1] ?? '';
  return withYear ? `${l} ${String(p.year).slice(2)}` : l;
}
